import { useForm } from 'react-hook-form';
import { FieldValues, UseFormProps, UseFormReturn } from 'react-hook-form/dist/types';

export function useHookForm<TFieldValues extends FieldValues = FieldValues, TContext = unknown>(
    props: UseFormProps<TFieldValues, TContext> = {}
): UseFormReturn<TFieldValues, TContext> {
    props.mode = 'onSubmit';
    return useForm(props);
}
